module.exports = "/images/loginDeliveryman.png";